import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { LungVolumeAnalysisListScreen } from "./LungVolumeAnalysisListScreen";
import { LungVolumeSessionsListScreen } from "./LungVolumeSessionsListScreen";
import { LungVolumeAnalysisScreen } from "./LungVolumeAnalysisScreen";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { SearchParams } from "../../Components/Query";

export const LungVolumeRoot = () => {
    const [analysisSetListQuery, setAnalysisSetListQuery] = React.useState<SearchParams>();

    return (
        <Switch>
            <PrivateRoute path="/LungVolume" exact permissions={[PermissionEnum.AccessSingleLungVolumeSession, PermissionEnum.AccessAllLungVolumeSessions, PermissionEnum.OverreadLungVolumeSession]}>
                <LungVolumeSessionsListScreen />
            </PrivateRoute>
            <PrivateRoute path="/LungVolume/Analysis" exact permissions={[PermissionEnum.OverreadLungVolumeSession]}>
                <LungVolumeAnalysisListScreen cachedQuery={analysisSetListQuery} setCachedQuery={setAnalysisSetListQuery} />
            </PrivateRoute>
            <PrivateRoute path="/LungVolume/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.OverreadLungVolumeSession, PermissionEnum.AccessSingleLungVolumeSession]}>
                <LungVolumeAnalysisScreen />
            </PrivateRoute>
        </Switch>
    );
}
